import * as React from 'react';

const SvgSuccessTick = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='72'
    height='72'
    viewBox='0 0 72 72'
    fill='none'
  >
    <path
      d='M36 6C19.47 6 6 19.47 6 36C6 52.53 19.47 66 36 66C52.53 66 66 52.53 66 36C66 19.47 52.53 6 36 6ZM50.34 29.1L33.33 46.11C32.91 46.53 32.34 46.77 31.74 46.77C31.14 46.77 30.57 46.53 30.15 46.11L21.66 37.62C20.79 36.75 20.79 35.31 21.66 34.44C22.53 33.57 23.97 33.57 24.84 34.44L31.74 41.34L47.16 25.92C48.03 25.05 49.47 25.05 50.34 25.92C51.21 26.79 51.21 28.2 50.34 29.1Z'
      fill='#FF0037'
    />
  </svg>
);

export default SvgSuccessTick;
